import { TopbarSearch } from '@/components/ui/TopbarSearch';
import type { CategoryFilters } from '../types/categoriesList.types';

interface CategoryToolbarProps {
  filters: CategoryFilters;
  onChange: (filters: CategoryFilters) => void;
}

export function CategoryToolbar({ filters, onChange }: CategoryToolbarProps) {
  return (
    <div className="rounded-md border border-slate-100 bg-white p-3 shadow-sm flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
      <div className="flex flex-row items-center gap-2 flex-1">
        <div className="flex-1 min-w-0">
          <TopbarSearch
            placeholder="Tìm kiếm danh mục (Tên, mã, phân loại...)"
            value={filters.query}
            onChange={(query) => onChange({ ...filters, query })}
          />
        </div>
      </div>
      <div className="flex flex-row items-center gap-2 overflow-x-auto">
        <select
          value={filters.status}
          onChange={(event) => onChange({ ...filters, status: event.target.value as CategoryFilters['status'] })}
          className="h-10 shrink-0 rounded-md border border-slate-200 bg-white px-2 text-xs text-slate-700 outline-none w-[110px] sm:w-[140px]"
        >
          <option value="all">Tất cả</option>
          <option value="active">Đang hoạt động</option>
          <option value="inactive">Tạm dừng</option>
        </select>
      </div>
    </div>
  );
}

